// extracted by mini-css-extract-plugin
export default {"root":"OrderFormYandexPayWidget_root__qCNa3","hidden":"OrderFormYandexPayWidget_hidden__uyAJo"};